import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=25e4c70a&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
import style0 from "./tab.vue?vue&type=style&index=0&id=25e4c70a&prod&lang=less&rel=stylesheet%2Fless&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e4c70a",
  null
  
)

export default component.exports